import { Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { SharedStorageKeyEnum } from 'src/app/shared/_config/storage/shared-storage-key-enum';
import { navWlcUrl } from 'src/app/shared/routing/routing.const';
import { SpxStorage, SpxStorageKeyEnum } from '@softpak/components/spx-storage';

@Injectable({
  providedIn: 'root'
})
export class SharedChannelGuard  {
  router = inject(Router);


  canActivate(): boolean {
    if (
      !SpxStorage.getSetting<SharedStorageKeyEnum>(SpxStorageKeyEnum.brand) ||
      !SpxStorage.getSetting<SharedStorageKeyEnum>(SpxStorageKeyEnum.channelType)
    ) {
      this.router.navigate([navWlcUrl]);
      return false;
    }
    return true;
  }
}
